import React from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import {ESSAY_MAX_CHAR} from "../config/common";
import {ESSAY_MAX_WORD} from "../config/common";
import strip from "striptags";

export default function Essay() {
    
    let app = ApplicantContainer.useContainer();

    let content = app.inStdValues.frEssay;
    
    function handleChange(evt) {
        
      evt.target.value = strip(evt.target.value);

      let words;
      if (content.trim().split(" ").length == limit){
        words = content.length;
      }else{
        words = 800;
      }

      

      // app.onChangeInStdValues({...app.inStdValues, [evt.target.id]:evt.target.value.slice(0, limit)});
      app.onChangeInStdValues({...app.inStdValues, [evt.target.id]:evt.target.value.slice(0, words)});
    }

    const limit = ESSAY_MAX_CHAR;   

    return (
<>
      {app.showEssay ?
      
      <Form.Row>
      <Col lg={12}>
      
        <Form.Group as={Col} controlId="frEssay" htmlFor="frEssay">
            <Form.Label>ESSAY</Form.Label>
              {app.inStdValues.frScholarship === "HOTELIER" ?
                 <Form.Text>Title: Why should I be selected as a Sunway University Young Hotelier scholarship by Sunway Resort and Hotels? ({ESSAY_MAX_WORD} words or less)</Form.Text>
              : app.inStdValues.frScholarship === "YOUNG CHEF" ?
               <Form.Text>Title: Why should I be selected as a Sunway University Young Chef? ({ESSAY_MAX_WORD} words or less)</Form.Text>
              : 
               <Form.Text>Title: Why should I be selected? ({ESSAY_MAX_WORD} words or less)</Form.Text>
              }
            <Form.Control required name="frEssay" as="textarea" rows={15}  onChange={e => {handleChange(e)}} value={content} />
            {/* <p>{content.length}/{limit}</p> */}
            <p>{content.trim().split(" ").length}/{limit}</p>
        </Form.Group>
      </Col>
      </Form.Row>        
      :
      ""}
      </>
    );
}